export const INITIAL_VALUES = {
  importCollaboratorFile: [],
};

export const validation = (key, intl) => {
  switch (key) {
    case "importCollaboratorFile":
      return [
        {
          validator: (_, value) => {
            if (value.fileList && value.fileList.length === 1) {
              return Promise.resolve();
            }
            return Promise.reject(
                new Error(
                    intl.formatMessage({ id: "error.field_required" })
                )
            );
          }
        },
      ];

    default:
      return [];
  }
};
